import React from 'react'

function Leadership() {
  return (
    <div>Leadership</div>
  )
}

export default Leadership